<template>
  <BoardView :pagination="pagination" :title="$t('title')" :total="total">
    <BoardTable
      :hasResults="!!total"
      :isFetching="isFetching"
      :pagination="pagination">
      <Row>
        <Column
          v-for="laptopGroup in results"
          :key="laptopGroup.laptopId"
          :xl="6">
          <RecordLaptopFlagged :laptopGroup="laptopGroup" />
        </Column>
      </Row>
    </BoardTable>
    <router-view />
  </BoardView>
</template>

<script>
import RecordLaptopFlagged from './components/RecordLaptopFlagged'
import Table from '@mixins/Table'
import { actions } from '@utils'
import { pluck } from 'rambda'
import { pluckId } from '@utils/collections'

export default {
  mixins: [Table],
  components: {
    RecordLaptopFlagged,
  },
  data() {
    const { authUser, hasRole } = this.$store.getters
    return {
      paginationOptions: {
        name: 'laptopFlagged',
        service: 'laptopFlagged',
        // searchIn: [
        //   'name',
        //   'asin',
        // ],
        customQuery: hasRole('>=ADMIN')
          ? {}
          : { userId: authUser.id },
        perPage: 12,
        tabs: [
          {
            label: this.$t('all'),
            value: null,
          },
          {
            label: 'Price not null',
            append: () => ({
              laptopFilters: {
                price: {
                  $ne: null,
                },
              },
            }),
          },
          {
            label: 'Price null',
            append: () => ({
              laptopFilters: {
                price: null,
              },
            }),
          },
        ],
        tabsIndexes: [0],
      },
    }
  },
  methods: {
    getLaptopImageIds(laptopIds) {
      const laptops = this.query('laptop', {
        id: {
          $in: laptopIds,
        },
      })

      return pluck('imageFileId', laptops)
        .filter(Boolean)
    },
    ...actions(
      'FETCH_FILE',
      'FETCH_ARTICLE_LAPTOP',
      'FETCH_LAPTOP',
    ),
  },
  watch: {
    async results(laptopGroups) {
      if (!laptopGroups.length) return

      const laptopIds = pluckId('laptopId', laptopGroups)

      const articleLaptopIds = laptopGroups.flatMap(laptopGroup => [
        ...laptopGroup.articleLaptopIds,
      ])

      this.LOAD(async () => {
        await Promise.all([
          this.FETCH_ARTICLE_LAPTOP({
            id: {
              $in: articleLaptopIds,
            },
          }),
          this.FETCH_LAPTOP({
            id: {
              $in: laptopIds,
            },
          }),
        ])

        await this.FETCH_FILE({
          id: {
            $in: this.getLaptopImageIds(laptopIds),
          },
        })
      })
    },
  },
}
</script>

<style lang="scss">
</style>

<i18n>
{
  "en": {
    "title": "Laptops Flagged",
    "all": "All"
  }
}
</i18n>
